import { render, staticRenderFns } from "./CreateEventPage.vue?vue&type=template&id=6ea19c2d&scoped=true"
import script from "./CreateEventPage.vue?vue&type=script&lang=js"
export * from "./CreateEventPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea19c2d",
  null
  
)

export default component.exports